import React from 'react'
import { connect } from 'react-redux'
import { showModal } from '../actions/modal'

import AutoSuggest from './AS'
import EventForm from './EventForm'

import CampaignsMenu from './CampaignsMenu'

const Header = (props) => (
  <header className="header2">
    <div className="header2__bg"></div>
    <div className="container">
      <AutoSuggest/>
      <div className="header2__buttons">
        <CampaignsMenu />
        <div className="menu__button" 
          onClick={() => props.showModal(EventForm)}>
          Add Event
        </div>
      </div>
    </div>
  </header>
)

export default connect(null, { showModal })(Header)
// export default Header


// WEBPACK FOOTER //
// ./src/components/Header.js